export const getPercentChange = (startingNumber: number, endingNumber: number): number => {
    return startingNumber && endingNumber ? ((endingNumber - startingNumber) / startingNumber) * 100 : 0;
};

export const arrayMedian = (arr: number[]): number => {
    const sortedArr = arr.sort((a, b) => a - b);
    const len = arr.length;
    const mid = Math.floor(len / 2);
    return len % 2 === 0 ? (sortedArr[mid - 1] + sortedArr[mid]) / 2 : (sortedArr[mid] ?? 0);
};

export const generateRangeArray = (start: number, end: number, step = 1): number[] => {
    const output: number[] = [];

    for (let i = start; i <= end; i += step) {
        output.push(i);
    }

    return output;
};
